module.exports = __webpack_public_path__ + "static/media/shookit_big.904be666.png";